import React from "react";
import { Box } from "@mui/material";
import { Cobweb, Spider } from "./sprites";

/**
 * A cobweb in a listing photo's top-right corner and a spider that lets itself
 * down from it, both hidden until the card is hovered.
 *
 * Shared by the public ListingCard and the panel's ObjectCard, whose photo
 * halves are meant to look the same. The photo box it goes in must be
 * position: relative with overflow: hidden, and the card's sx must spread
 * CARD_SPOOK_HOVER, which is what reveals it.
 */

var WEB = {
  position: "absolute",
  top: 0,
  right: 0,
  width: 78,
  height: 78,
  transform: "scaleX(-1)",
  opacity: 0,
  transition: "opacity .35s ease",
  pointerEvents: "none",
  filter: "drop-shadow(0 0 1px rgba(0,0,0,0.55))",
};

var SPIDER = {
  position: "absolute",
  top: 0,
  right: 26,
  width: 18,
  transform: "translateY(-66px)",
  transition: "transform .5s cubic-bezier(.3,.7,.4,1)",
  pointerEvents: "none",
};

/** Spread into the card's sx: an orange hover glow, and the hover that reveals the spooks. */
export var CARD_SPOOK_HOVER = {
  "&:hover": {
    transform: "translateY(-3px)",
    boxShadow: "0 14px 34px rgba(255,122,26,0.2)",
    borderColor: "rgba(255,122,26,0.55)",
  },
  "&:hover .hw-card-web": { opacity: 1 },
  "&:hover .hw-card-spider": { transform: "translateY(0)" },
};

export default function CardSpooks() {
  return (
    <React.Fragment>
      <Cobweb className="hw-card-web" color="rgba(255,255,255,0.85)" style={WEB} />
      <Box className="hw-card-spider" sx={SPIDER}>
        <Box
          sx={{ width: "1px", height: 46, mx: "auto", background: "rgba(255,255,255,0.8)" }}
        />
        {/* Clicks go to the card underneath, not to the spider. */}
        <Spider
          style={{
            display: "block",
            width: 18,
            height: "auto",
            marginTop: -2,
            pointerEvents: "none",
          }}
        />
      </Box>
    </React.Fragment>
  );
}
